import { render, staticRenderFns } from "./suspensionDrawer.vue?vue&type=template&id=c17fc5e4&scoped=true&"
import script from "./suspensionDrawer.vue?vue&type=script&lang=js&"
export * from "./suspensionDrawer.vue?vue&type=script&lang=js&"
import style0 from "./suspensionDrawer.vue?vue&type=style&index=0&id=c17fc5e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17fc5e4",
  null
  
)

export default component.exports